import { Component, OnInit } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Something_went_wrong, Request_Thank_You } from "@root/app.constant";
import { Urls } from "../../../utils/urls";
import { ApiService } from "../../../shared/services/api.service";
import { CommonDataService } from "../../../shared/services/common-data.service";
import { environment } from "../../../../environments/environment.prod";

@Component({
  selector: "app-regulatory-message-display",
  templateUrl: "./regulatory-message-display.component.html",
  styleUrls: ["./regulatory-message-display.component.scss"],
})
export class RegulatoryMessageDisplayComponent implements OnInit {
  flag: number;
  dateFlag: boolean = false;
  banners:any=[]
  mobileBanners:any=[]

  constructor(
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    // this.setFlag();
    // console.log('Date flag -->', this.dateFlag);

    // if (this.dateFlag) {
    //   this.flag = 3;
    // }
    // else {
    //   this.flag = 2;
    // }
    // this.panAdhaarBanner();
    this.banners=[
      {
        name: "NFO",
        filePath:'assets/images/ITI-Large-&-Mid-Cap-Fund-Desktop-Banner.jpg'
      },
      {
      name: "KYC",
        filePath:'assets/images/UPDATE-YOUR-KYC-STATUS-Desktop.png'
      }
    ]
    this.mobileBanners=[
    {
      name: "NFO",
      filePath:'assets/images/ITI-Large-&-Mid-Cap-Fund-Desktop-Banner.jpg'
    },
    {
    name: "KYC",
      filePath:'assets/images/UPDATE-YOUR-KYC-STATUS-Mobile.png'
    }
  ]
  }

  panAdhaarBanner() {
    setTimeout(() => {
      this.flag = 1;
      this.nominationUpdationBanner();
    }, 5000);
  };


  nominationUpdationBanner() {
    setTimeout(() => {
      this.flag = 2;

      if (this.dateFlag) {
        this.vigilanceWeekBanner();
      }
      else {
        this.panAdhaarBanner();
      }
    }, 5000);
  }

  vigilanceWeekBanner() {
    setTimeout(() => {
      this.flag = 3;
      this.panAdhaarBanner();
    }, 5000);
  }

  redirectTo(bannerName) {
    if(bannerName=="KYC"){
      if (!environment.isDRBuild) {
        if (environment.baseurl === "https://dev.itiamc.com:8485/jeeth/api/v1/catalog/") {
          window.open("https://dev.itiamc.com:8486/#/login/kyc", "_blank"); // UAT-inv
        }
        else if (environment.baseurl === "https://itiamc.com/jeeth/api/v1/catalog/") {
          window.open("https://investonline.itiamc.com/#/login/kyc", "_blank"); // Prod-inv
        }
        else {
          window.open("https://investonline.itiamc.com/#/login/kyc", "_blank"); // Prod-inv
        }
      }
      else {
        window.open("https://investonline.itiamc.com/#/login/kyc", "_blank"); //DR-inv
      }
    }
    else if(bannerName=="NFO"){
      if (!environment.isDRBuild) {
        if (environment.baseurl === "https://dev.itiamc.com:8485/jeeth/api/v1/catalog/") {
          window.open("https://dev.itiamc.com:8485/nfo", "_blank"); // UAT-inv
        }
        else if (environment.baseurl === "https://itiamc.com/jeeth/api/v1/catalog/") {
          window.open("https://itiamc.com/nfo", "_blank"); // Prod-inv
        }
        else {
          window.open("https://itiamc.com/nfo", "_blank"); // Prod-inv
        }
      }
      else {
        window.open("https://drcatalog.itiamc.com/nfo", "_blank"); //DR-inv
      }
    }
  
    // if (flag === 1) {
    //   window.open('https://eportal.incometax.gov.in/iec/foservices/#/pre-login/bl-link-aadhaar', "_blank");
    // }
    // else if (flag === 2) {
    //   window.open('https://mfs.kfintech.com/investor/General/NCTNomineeUpdation', "_blank");
    // }
    // else if (flag === 3) {
    //   window.open('https://pledge.cvc.nic.in/', "_blank");
    // }
  }

  closeModal = () => {
    this.activeModal.close();
  };

  setFlag() {
    // Display Vigilance Awareness Week banner from 1st Nov 2023 to 5th Nov 2023
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth();
    var day = date.getDate();

    if (year == 2023 && month == 10) {
      if (day >= 1 && day <= 5) {
        this.dateFlag = true;
        console.log('Today -->', date);
      }
      else {
        this.dateFlag = false;
      }
    }
  }
}
